import {styled} from "@mui/material";
import {HoverElevationButton} from "./base-buttons";

export const CalculateButton = styled(HoverElevationButton)(({theme}) => ({
    backgroundColor: theme.barekam.actionbar.buttons.newOrder.backgroundColor,
    color: '#FFF',

    padding: '18px 24px 18px 18px',
    height: '60px',

    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',
    borderRadius: '0.5rem',

    '&:hover': {
        backgroundColor: theme.barekam.actionbar.buttons.newOrder.backgroundColor,
    }
}));